export default __webpack_public_path__ + "static/N0185-eb953b229d1cdaeed6d3e3d6c23a9b54.png";